<template>
    <div>
        <div class="modal-card" style="width: auto">
        <header class="modal-card-head">
            
            <p class="modal-card-title">Designaciones</p>

        </header>
        
        
        <section class="modal-card-body">
        
        <b-table
                
                :data="getList"
                focusable
                style="font-size: 0.8em;">

                <template slot-scope="props">

                    <b-table-column field="designation_name" :label="'Designacion'">
                        
                        <b-input type="text" size="is-small" v-model="props.row.designation_name">

                        </b-input>
                        
                        
                    </b-table-column>

                    <b-table-column>
                        
                        <div style="text-align: right">

                            <a @click="update(props.row)" :title="'salvar'">
                                <i class="material-icons" style="font-size: 16px;">save</i>
                            </a>

                            <a @click="deleteData(props.row)" 
                                v-if="(getList.length - 1)>0 && (getList.length - 1)!=props.row.key" :title="'eliminar'">
                                <i class="material-icons" style="font-size: 16px;">remove_circle_outline</i>
                            </a>
                            
                        </div>
                    </b-table-column>

                </template>
            </b-table>
        </section>
        </div>
    </div>
</template>

<script>
export default {
    computed: {
        getList() {
            return this.$store.getters.getDesignationList
        }
    },
    methods: {
        update(prop) {
            
            this.$store.dispatch('createOrUpdateData', {
                target: 'postDesignation',
                permissions: this.$store.getters.getCurrentPathProps,
                targetParameters: prop,
                targetAction: prop.id>0?1:0 // 0 = create, edit = 1, delete = 2
            })
        },
        deleteData(prop) {
            
            this.$store.commit('setConfirmBox', 
            {
                title: 'message.warning', message: '¿Estás seguro de proceder?',
                followingAction: {
                    target: 'deleteData',
                    permissions: this.$store.getters.getCurrentPathProps,
                    targetParameters: {actionPath: '/designations/delete.php', listActionName: 'fetchDesignation', 
                        data: [prop.id], payload: null},
                    targetAction: 2,
                }
            }
            )
        }
    }
    
}
</script>

<style>

</style>



// WEBPACK FOOTER //
// src/modules/Designation/Index.vue